module.exports = __webpack_public_path__ + "static/img/guanbihuiyi2.65b8440.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/guanbihuiyi2.png
// module id = YL/R
// module chunks = 24